import React from "react";
import { FaInfoCircle } from 'react-icons/fa';
import moment from "moment";
import * as dayjs from "dayjs";

const unavailableExpectedDate = moment().add(28, "d").toDate(); //For regular
//const unavailableExpectedDate = moment("2022-02-20").toDate();   //For holiday
const SeparatelyExpectedDateInsideDhaka = moment().add(2, "d").toDate();
const SeparatelyExpectedDateOutSideDhaka = moment().add(3, "d").toDate();

const Stock = ({ product }) => {
  return (
    <>
      {product.quantity <= 0 ? (
        <>
        
        </>
      ) : (
        <>
          <span 
          style={{ background: "#dcfce7" }}
          className="bg-emerald-700 text-teal-600 rounded-full inline-flex items-center justify-center px-2 py-1 text-xs font-semibold mt-2 font-serif">
           {product.quantity} In Stock
          </span>          
        </>
      )}
      <div>
        {product.quantity <= 0 && product.ispreOrderAllowed && (
          <div className="bg-blue-100 p-4 rounded-md mt-2 mb-2" id="preorderText">
          <h4 className="text-lg font-bold mb-2 flex items-center">
            <span className="text-blue-500 mr-2">
              <FaInfoCircle />
            </span>
           <span> Pre-order item</span>
          </h4>
          <p className="mb-4">
            Not available for immediate delivery. You can pre-order it today at no payment. We will order for you and deliver once it arrives. You can pay during delivery.
          </p>
          <strong className="block mb-2">Expected delivery {unavailableExpectedDate.toDateString()}</strong>         
        </div>
          
        )}
        {product.quantity > 0 && product.ispreOrderAllowed && (
          <div className="mt-2 mb-2 bg-green-100 p-4 rounded-md" id="instocktext">
          <h4 className="text-lg font-bold mb-2 flex items-center">
            <span className="text-green-600 mr-2">
              <FaInfoCircle />
            </span>
           <span> In stock item</span>
          </h4>
          <p className="mb-4">
            Available right now at our Dhaka warehouse.
          </p>
          <strong className="block mb-2">Expected delivery {SeparatelyExpectedDateOutSideDhaka.toDateString()}</strong>         
        </div>
          
        )}
        {product.quantity == 0 && !product.ispreOrderAllowed && (
          <div className="mt-2 mb-2 bg-red-100 p-4 rounded-md" id="instocktext">
          <h4 className="text-lg font-bold mb-2 flex items-center">
            <span className="text-red-600 mr-2">
              <FaInfoCircle />
            </span>
           <span> Out of Production</span>
          </h4>
          <p className="mb-4">
            This item has been discontinued by the factory permanently. You cannot order it anymore.
          </p>             
        </div>
          
        )}
      </div>
    </>
  );
};

export default Stock;
